/**
 * AmbientDust — 10 tiny gold dust motes floating upward like sunlight
 * through a library window. Pure CSS animation, zero JS runtime cost.
 */
const MOTES = Array.from({ length: 10 }, (_, i) => ({
  id: i,
  left: `${8 + i * 9}%`,
  size: 2 + (i % 3),
  delay: `${i * 2.1}s`,
  duration: `${17 + (i % 4) * 2.5}s`,
  opacity: 0.15 + (i % 3) * 0.07,
}));

export default function AmbientDust() {
  return (
    <div
      className="ambient-dust-container"
      aria-hidden="true"
      style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 1 }}
    >
      {MOTES.map((m) => (
        <div
          key={m.id}
          style={{
            position: 'absolute',
            left: m.left,
            bottom: '-10px',
            width: m.size,
            height: m.size,
            borderRadius: '50%',
            backgroundColor: 'var(--ambient-dust-color, #D4A574)',
            opacity: m.opacity,
            animation: `dust-float ${m.duration} ${m.delay} ease-in-out infinite`,
          }}
        />
      ))}
    </div>
  );
}
